module.exports = __webpack_public_path__ + "static/img/LogoOrange.449dbf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LogoOrange.jpg
// module id = GYxU
// module chunks = 1